import * as React from 'react';

function SvgTimer(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={25} height={29} fill="none" viewBox="0 0 25 29" {...props}>
      <path
        fill="#04006C"
        d="M15.667.333h-5.334C9.6.333 9 .933 9 1.667 9 2.4 9.6 3 10.333 3h5.334C16.4 3 17 2.4 17 1.667c0-.734-.6-1.334-1.333-1.334zM13 17.667c.733 0 1.333-.6 1.333-1.334V11c0-.733-.6-1.333-1.333-1.333s-1.333.6-1.333 1.333v5.333c0 .734.6 1.334 1.333 1.334zm9.373-8.814l1-1a1.324 1.324 0 000-1.866l-.013-.014a1.324 1.324 0 00-1.867 0l-1 1A11.949 11.949 0 0013 4.333c-6.4 0-11.84 5.28-12 11.68-.173 6.774 5.253 12.32 12 12.32 6.64 0 12-5.373 12-12a11.95 11.95 0 00-2.627-7.48zM13 25.667a9.327 9.327 0 01-9.333-9.334A9.326 9.326 0 0113 7a9.326 9.326 0 019.333 9.333A9.327 9.327 0 0113 25.667z"
      />
    </svg>
  );
}

export default SvgTimer;
